import React from "react";
import { useNavigate } from "react-router-dom";
import { BackButton } from "@twa-dev/sdk/react";

import { isTelegramMiniApp } from "../utils/platform";
import "./PlatformBackButton.css";

/**
 * Кнопка «назад».
 *
 * В Telegram это системная кнопка в шапке мини-аппа — её рисует сам клиент.
 * В браузере такой шапки нет, поэтому рисуем свою: без неё на внутренних
 * страницах некуда нажать, кроме кнопки браузера, которой в установленном
 * приложении тоже нет.
 */
const PlatformBackButton: React.FC = () => {
  const navigate = useNavigate();

  if (isTelegramMiniApp) {
    return <BackButton />;
  }

  return (
    <div style={{ textAlign: "left", maxWidth: 640, margin: "0 auto 8px" }}>
      <button
        type="button"
        className="web-back-button"
        onClick={() => navigate(-1)}
        aria-label="Back"
      >
        ←
      </button>
    </div>
  );
};

export default PlatformBackButton;
